import React from "react"
import { Navigate, Route } from "react-router-dom"

import withRouter from "app/static/frontend/routing/withRouter"
import SearchNew from "app/static/frontend/search-new/Search"
import paths from "app/static/frontend/imports/desktopPaths"
import { ancillaryFLVs, getCurrentRegionSearchOptions, getInitialSearch } from "shared/search/search-page-options"

const searchBasePath = paths.search

export const getSearchPath = (page) => {
    const pageUrl = page.quorumDataType.search_url
    return `${searchBasePath}${pageUrl}`
}

export const getCurrentWebSearchOptions = () => getCurrentRegionSearchOptions().filter((page) => !page.mobileOnly)

export const getSearchPathFromQDT = (qdt: number) => {
    // the user should only ever have one FLV per QDT! We have multiple
    // options per QDT, but there should only be one ever showing up.
    const searchPage = getCurrentWebSearchOptions().find((page) => page.quorumDataType.value === qdt)

    return searchPage ? getSearchPath(searchPage) : searchBasePath
}

export const uniqueFlvIdFromSearchPath = (path: string) => {
    const searchPage = getCurrentWebSearchOptions().find((page) => path === getSearchPath(page))
    return searchPage && searchPage.uniqueFlvId
}

export const getFLVFromQDT = (qdt: number) => {
    const searchPage = getCurrentWebSearchOptions().find((page) => page.quorumDataType.value === qdt) || {
        filterableListViewComponent: ancillaryFLVs[qdt],
    }

    return searchPage && searchPage.filterableListViewComponent
}

export const getUniqueFLVIdFromQDT = (qdt) => {
    const searchPage = getCurrentWebSearchOptions().find((page) => page.quorumDataType.value === qdt) || {
        filterableListViewComponent: ancillaryFLVs[qdt],
    }

    // @ts-expect-error This is probably a bug - if we are on an ancillaryFLVs, there may not be a uniqueFlvId to return
    return searchPage && searchPage.uniqueFlvId
}

const defaultPath = getSearchPath(getInitialSearch())

const routes = getCurrentWebSearchOptions().map((page) => {
    const FLV = withRouter(page.filterableListViewComponent)
    const uniqueFlvId = page.uniqueFlvId

    return (
        <Route
            key={page.uniqueFlvId}
            path={getSearchPath(page).replace(searchBasePath, "")}
            Component={(props) => <FLV uniqueFlvId={uniqueFlvId} {...props} />}
        />
    )
})

export const SearchNewRoutes = (
    <Route path={searchBasePath} Component={withRouter(SearchNew)}>
        <Route index element={<Navigate to={defaultPath} />} />
        {routes}
    </Route>
)
